import React from "react";
import { Flex } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { Activities } from "src/modules/activity-log/activity";
import BouncingDotsLoader from "src/components/BouncingDotsLoader";
import RoundButton from "../RoundButton";
import { ReactComponent as MicrophoneIcon } from "./microphone.svg";
import { ReactComponent as Voice } from "src/modules/parent-station/scenes/Monitors/icons/voice.svg";
import VoiceAnimation from "./VoiceAnimation";
import { ResponsiveCaption } from "../ResponsiveCaption";
import environment, { getAppValue } from "src/utils/environment";

class PttButton extends React.Component {
  state = {
    showBouncingDots: false
  };
  loaderTimeoutId = null;

  componentDidUpdate(prevProps, prevState) {
    const { state } = this.props;
    if (state !== prevProps.state) {
      if (state === "starting") {
        this.loaderTimeoutId = setTimeout(() => this.setState({ showBouncingDots: true }), 100);
      } else if (this.loaderTimeoutId) {
        clearTimeout(this.loaderTimeoutId);
        this.loaderTimeoutId = null;
        this.setState({ showBouncingDots: false });
      }
    }
  }

  componentWillUnmount() {
    const { state, togglePushToTalk } = this.props;
    if (state === "on") {
      togglePushToTalk();
    }
  }

  render() {
    const { showBouncingDots } = this.state;
    const {
      t,
      isDarkMode,
      togglePushToTalk,
      state,
      root,
      noiseMeter,
      mode,
      activity,
      bg,
      showMicrophoneIcon,
      // size = ["40px", "56px", "64px"]
      size = "10.69vmin"
    } = this.props;
    const hasShadow = isDarkMode === false && state === "on";
    return (
      <Flex flexDirection="column" alignItems="center" {...root}>
        <RoundButton
          bg={state === "on" ? "white" : bg}
          iconSize="50%"
          size={size}
          icon={getAppValue({
            barkio: showMicrophoneIcon ? MicrophoneIcon : Voice,
            bibino: MicrophoneIcon
          })}
          iconFill="white"
          onClick={togglePushToTalk}
          mb="4px"
          boxShadow={
            hasShadow
              ? "0 2px 4px -1px rgba(0, 0, 0, 0.12), 0 1px 16px 0 rgba(0, 0, 0, 0.06), 0 4px 8px 0 rgba(0, 0, 0, 0.08)"
              : "none"
          }
        >
          {state === "on" && noiseMeter && <VoiceAnimation noiseMeter={noiseMeter} />}
        </RoundButton>
        {environment.isBarkio && (
          <ResponsiveCaption
            color={isDarkMode || mode === "video" || activity === Activities.AWAKE ? "white70" : "black54"}
            lineHeight="1.6"
            height={[`${1.6 * 10}px`, `${1.6 * 14}px`, `${1.6 * 16}px`]}
          >
            {showBouncingDots ? (
              <BouncingDotsLoader bg={isDarkMode ? "white70" : "black54"} mt="8px" />
            ) : (
              t("buttons.talk")
            )}
          </ResponsiveCaption>
        )}
      </Flex>
    );
  }
}

export default withTranslation()(PttButton);
